import React from "react";
import {useRouteMatch} from "react-router";
import {LayoutWrapper} from 'bukku/components/Layout/LayoutWrapper';
import {Styled} from "bukku/containers/App/DeniedPage/style";
import {NotInSubscription} from "bukku/containers/App/DeniedPage/NotInSubscription";
import {NoPermission} from "bukku/containers/App/DeniedPage/NoPermission";
import {AccessSpecs} from "./AccessChecker/AccessSpecs";
import {AccessChecker} from "./AccessChecker";
import { GenericNotAllowedPage } from "../../containers/App/DeniedPage/GenericNotAllowedPage";
// import {PermissionSubscriptionCheck} from "./helper/PermissionSubscriptionCheck";

function RouteAccess(props) {
    const match = useRouteMatch();
    const { children } = props;

    const url = match.path;
    const accessSpec = new AccessSpecs().getFromUrl(url);
    const {
        permission, subscription, integration,
        miscellaneous, miscellaneousResult,
        access,
    } = new AccessChecker(accessSpec).detailedCheck();

    if (access)
    // const checker = PermissionSubscriptionCheck.withUrl(match.path);
    // const { permission, inhibitedByModifier, subscription, allowed } = checker.hasPermissionTo();
    // console.log('aaa RouteAccess', checker.hasPermissionTo(), props);
    // if (allowed)
        return children;

    // No Access Content
    let content;
    if (!subscription) {
        content = <NotInSubscription accessKeys={accessSpec.subscription.keys} />;
    }

    // else if (!permission || draftOnlyModifier)
    else if (!permission || !integration) {
        content = <NoPermission accessKeys={accessSpec.permission.keys} />;
    }

    else if (!miscellaneous) {
        const {
            allowedCountryCodes,
            settingsRequired,
            appsRequired,
        } = miscellaneousResult;

        if (!allowedCountryCodes.allowed) {
            content = <GenericNotAllowedPage
                icon={allowedCountryCodes.iconIfBlocked}
                message={allowedCountryCodes.messageIfBlocked}
            />;
        }
        else if (!settingsRequired.allowed) {
            content = <GenericNotAllowedPage
                icon={settingsRequired.iconIfBlocked}
                message={settingsRequired.messageIfBlocked}
            />;
        }
        else if (!appsRequired.allowed) {
            content = <GenericNotAllowedPage
                icon={appsRequired.iconIfBlocked}
                message={appsRequired.messageIfBlocked}
            />;
        }
    }

    return (
        <LayoutWrapper>
            <Styled>{ content }</Styled>
        </LayoutWrapper>
    );
}

export default RouteAccess;
